<template>
  <NuxtLink
    :to="path"
    :title="title"
    class="tw-block hover:tw-bg-gray-50 tw-duration-200"
  >
    <QCard
      flat
      class="tw-w-full tw-duration-200 hover:tw-bg-gray-50"
      @click="$emit('click')"
    >
      <QCardSection
        horizontal
        :class="customArticleCardHorizontal"
        class="tw-w-full tw-grid"
      >
        <QCardSection
          class="tw-p-0"
        >
          <MediaImageLazyLoad
            :src="image?.medium || ''"
            :placeholder-src="image?.tiny || ''"
            :alt="title"
            :ratio="ratio"
            class="tw-w-full tw-h-full"
            custom-class="tw-rounded-lg"
            seo-optimize
          />
        </QCardSection>

        <QCardSection
          class="tw-flex tw-flex-col tw-py-0 tw-px-0 tw-w-full"
        >
          <div
            class="tw-line-clamp-2 tw-text-mb-title-4 lg:tw-text-mb-title-4"
          >
            {{ title }}
          </div>
          <div
            v-if="description && description !== ''"
            class="
              tw-w-full
              tw-text-mb-body-small tw-text-dark-gray
              tw-word-break-normal
              tw-line-clamp-2
            "
          >
            {{ description }}
          </div>

          <DisplayPrice
            :options="options"
            :show-options-divider="false"
            :show-option-list="showOptionList"
            :min-price-option="minPriceOption"
            :max-price-option="maxPriceOption"
            :min-price-of-discounted-option="minPriceOfDiscountedOption"
            :max-price-of-discounted-option="maxPriceOfDiscountedOption"
            :price="price"
            :price-of-discounted="priceOfDiscounted"
          />
        </QCardSection>
      </QCardSection>
    </QCard>
  </NuxtLink>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  image: ImageMeta
  date?: string
  title?: string
  path?: string
  description?: string
  categoryTitle?: string
  categoryPath?: string
  ratio?: number
  colFirst?: number
  // Price display related props
  options?: ProductOption[]
  price?: number
  priceOfDiscounted?: number
  minPriceOption?: number
  maxPriceOption?: number
  minPriceOfDiscountedOption?: number
  maxPriceOfDiscountedOption?: number
  showOptionList?: boolean
  customArticleCardHorizontal?: string
}>(), {
  date: '',
  title: '',
  path: '',
  description: '',
  categoryTitle: '',
  categoryPath: '',
  ratio: 0,
  colFirst: 6,
  options: () => [],
  price: 0,
  priceOfDiscounted: 0,
  minPriceOption: 0,
  maxPriceOption: 0,
  minPriceOfDiscountedOption: 0,
  maxPriceOfDiscountedOption: 0,
  showOptionList: false,
  customArticleCardHorizontal: 'tw-grid-cols-2 tw-gap-3'
})

defineEmits<{(e: 'click'): void}>()
</script>
